export enum StatusDocumentoEnum {
  NAO_AVALIADO = "Não avaliado",
  ACEITO = "Aceito",
  REJEITADO = "Rejeitado"
}
